<template>
	<section class="newsletter-section">
		<div class="row">
			<div class="columns column12 align-center">
				<h2>{{ header }}</h2>
				<div v-parse-links v-html="content" />
			</div>
			<div class="columns column12">
				<form class="newsletter">
					<input type="text" :placeholder="$t('formEmail')" />
					<font-awesome-icon :icon="`fa-sharp fa-regular fa-envelope`" size="1x" />
					<input type="submit" class="button" :value="button" />
				</form>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	header: { type: String, default: '' },
	content: { type: String, default: '' },
	button: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.newsletter-section {
	padding: 40px 0 70px;
	margin: 0;
	background: var(--blue-background);
	border-bottom: none;

	h2,
	h3 {
		margin: 0 0 20px;
	}

	form {
		margin-top: 30px;
		display: flex;
		flex-flow: row wrap;
		align-items: center;
		justify-content: center;
		position: relative;

		input {
			background: var(--blue-background-input);
			padding: 20px 25px;
			height: 62px;
			border: none;
			width: 48%;
			max-width: 250px;
			vertical-align: top;
			font-family: var(--body-font-family);
			font-size: 17px;

			&::placeholder {
				color: #333;
			}

			&.button {
				line-height: 22px;
				margin: 0;
				width: auto;
				padding: 14px 30px;
				background: #000;
				color: #fff;
				max-width: 200px;

				&:hover {
					background: #111;
					color: #fff;
				}
			}
		}

		svg {
			position: absolute;
			margin-left: 60px;
		}
	}
}

@media (max-width: 480px) {
	.newsletter-section {
		form {
			svg {
				margin-right: 5%;
				margin-left: 0;
			}
		}
	}
}
</style>
